(() => {
  const mq = window.matchMedia('(max-width: 749px)');
  let form = null;
  let sentinel = null;
  let ticking = false;
  let onScroll = null;
  let onResize = null;

  function cleanup() {
    if (onScroll) {
      window.removeEventListener('scroll', onScroll, { passive: true });
      onScroll = null;
    }

    if (onResize) {
      window.removeEventListener('resize', onResize);
      onResize = null;
    }

    ticking = false;

    if (form) {
      form.classList.remove('is-sticky');
    }

    if (sentinel) {
      sentinel.style.height = '';
    }
  }

  function getFormHeight() {
    if (form.classList.contains('is-sticky')) {
      const reserved = parseFloat(sentinel.style.height);
      if (reserved > 0) return reserved;
    }

    return form.offsetHeight;
  }

  function setSticky(shouldStick) {
    if (!form || !sentinel) return;

    if (shouldStick) {
      if (!form.classList.contains('is-sticky')) {
        sentinel.style.height = `${form.offsetHeight}px`;
        form.classList.add('is-sticky');
      }
      return;
    }

    form.classList.remove('is-sticky');
    sentinel.style.height = '';
  }

  function update() {
    ticking = false;

    if (!mq.matches || !form || !sentinel) {
      setSticky(false);
      return;
    }

    const height = getFormHeight();
    const stickLine = window.innerHeight - height;
    // Latch as soon as the button reaches the bottom of the viewport.
    const shouldStick = sentinel.getBoundingClientRect().top <= stickLine;
    setSticky(shouldStick);
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  function bind() {
    cleanup();

    if (!mq.matches || !form || !sentinel) return;

    onScroll = requestUpdate;
    onResize = requestUpdate;
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    update();
  }

  function init() {
    form = document.querySelector('.pdp-redesign product-form.product-form');
    if (!form) return;

    if (!form.previousElementSibling?.classList?.contains('pdp-sticky-atc-sentinel')) {
      sentinel = document.createElement('div');
      sentinel.className = 'pdp-sticky-atc-sentinel';
      sentinel.setAttribute('aria-hidden', 'true');
      form.parentNode.insertBefore(sentinel, form);
    } else {
      sentinel = form.previousElementSibling;
    }

    bind();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  mq.addEventListener('change', bind);
  document.addEventListener('shopify:section:load', init);
})();
